<template>
  <div class="calico-card-page">
    <div class="calico-card-container">
      <div class="calico-card-row">
        <div style="width: 300px;">
          <CalicoCard
            value="card1"
            title="Custom Title"
            :img-src="imageSrc"
            disabled
            description="This is a Multi-Function Card element. This is a complex card that has multiple zones of interaction—a clickable content area, and a footer with buttons."
          />
        </div>
        <div style="width: 300px;">
          <CalicoCard
            value="card2"
            title="Custom Title"
            :img-src="imageSrc"
            description="This is a Multi-Function Card element. This is a complex card that has multiple zones of interaction—a clickable content area, and a footer with buttons."
          />
        </div>
      </div>
      <div class="calico-card-row">
        <div style="width: 600px;">
          <CalicoCard
            value="card2"
            title="Custom Title"
            :img-src="imageSrc"
            inline
            description="This is a Multi-Function Card element. This is a complex card that has multiple zones of interaction—a clickable content area, and a footer with buttons."
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalicoCard from '@/components/calico/card/index.vue';
import imageSrc from "@/assets/8d65b59951f81dfc3987350717385fc3.jpeg";

export default {
  name: 'CalicoCardPage',
  components: {
    CalicoCard,
  },
  data() {
    return {
      imageSrc
    };
  },
};
</script>

<style lang="scss">
.calico-card-page {
  display: flex;
  justify-content: center;
  align-items: center;
  .calico-card-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 100%;
    .calico-card-row {
      @include inline-space($space-large);
      @include inset-space($space-large);
    }
  }
}
</style>